// extracted by mini-css-extract-plugin
export default {"darkTheme":"Table_darkTheme__sVdyi","rows":"Table_rows__HQKtH","text":"Table_text__0V6Qq","large":"Table_large__lQx3k"};